import { createActionNamespace } from 'Modules/core/redux';

import {
    DownloadAction,
    ProgressAction, FinishAction,
} from './types';


const downloadsAction = createActionNamespace('downloads');

export const downloadsActions = {
    initialize: downloadsAction<null>('INITIALIZE'),
    download: downloadsAction.withPath<DownloadAction>('DOWNLOAD'),
    progress: downloadsAction.withPath<ProgressAction>('PROGRESS'),
    finish: downloadsAction.withPath<FinishAction>('FINISHED'),
};
